import $http from "@/http/index";

//查询友情链接列表
export const blogrollList = (data) => {
  return $http.get("/api/blogroll/list", {
    params: data
  })
}
